module.exports = [{"title":"About Us","href":"/"},{"title":"Projects","href":"/projects/"},{"title":"Contact Us","href":"/#contact-us"}]